import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider,
} from "antd";
import dayjs from "dayjs";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { get_dist_and_retailers, Get_User_Details, Get_user_ledger, get_users_ledger } from "../../../apicall";
const { Search } = Input;
const { RangePicker } = DatePicker;




const Mappedusers = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const [userStatustype, setUserstatus] = useState("ALL");
    const [searchuser, setSearchuser] = useState("");
    const [UsersDrawer, setUsersDrawer] = useState(false);
    const [selectedUser, setSelecteduser] = useState(null);
    const [whichuserLedger, setwhichUserledger] = useState({
        userType: "Retailer",
        selectedUser: null,
    });
    const [userprofileLoading, setUserprofileLoading] = useState(true); // self profile
    const [selfProfiledetails, setProfiledetails] = useState(''); // Self profile 
    const [userfindloading, setUserloading] = useState(false);
    const [mappedUsers, setMappedUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);

    const handleSearch = () => {
        let filtered = [...mappedUsers];

        // Status Filter
        if (userStatustype !== "ALL") {
            filtered = filtered.filter((item) =>
                userStatustype === "Active"
                    ? !item.isaccountblocked
                    : item.isaccountblocked
            );
        }

        // Search Filter
        if (searchuser.trim()) {
            const keyword = searchuser.toLowerCase().trim();

            filtered = filtered.filter((item) =>
                item.userName?.toLowerCase().includes(keyword) ||
                item.userCode?.toLowerCase().includes(keyword) ||
                String(item.mobile).includes(keyword)
            );
        }

        setFilteredUsers(filtered);
    };

    const handleReset = () => {
        setUserstatus("ALL");
        setSearchuser("");
        setFilteredUsers(mappedUsers);
    };

    const columns = [
        {
            title: "S.No.",
            width: 60,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "User Code",
            dataIndex: "userCode",
            width: 120,
            render: (code) => <Text copyable>{code}</Text>,
        },
        {
            title: "Name",
            dataIndex: "userName",
            width: 180,
        },
        {
            title: "Business Name",
            dataIndex: "business_name",
            width: 220,
        },
        {
            title: "Account Type",
            dataIndex: "acc_type",
            width: 120,
            render: (type) => (
                <Tag color={type === "Retailer" ? "blue" : "purple"}>
                    {type}
                </Tag>
            ),
        },
        {
            title: "Mobile",
            dataIndex: "mobile",
            width: 130,
            render: (mobile) => <Text copyable>{mobile}</Text>,
        },
        {
            title: "City",
            dataIndex: "city",
            width: 120,
        },
        {
            title: "State",
            dataIndex: "state",
            width: 120,
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            width: 100,
        },
        {
            title: "Created On",
            dataIndex: "createdAt",
            width: 170,
            render: (date) => dayjs(date).format("DD MMM YYYY"),
        },
        {
            title: "Action",
            width: 110,
            fixed: "right",
            render: (_, record) => (
                <Button
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setSelecteduser(record);
                        setUsersDrawer(true);
                    }}
                >
                    View
                </Button>
            ),
        },
    ];
    const userTypeOptions = selfProfiledetails?.acc_type === "Distributor"
        ? [
            {
                value: "Retailer",
                label: "Retailers",
            },
        ]
        : [
            {
                value: "Retailer",
                label: "Retailers",
            },
            {
                value: "Distributor",
                label: "Distributors",
            },
        ];
    const handleUserTypeChange = async (value) => { // onchange + fetch inside user according to user type
        setwhichUserledger((prev) => ({
            ...prev,
            userType: value,
            selectedUser: null,
        }));
        try {
            setUserloading(true);
            const data = await get_dist_and_retailers();
            if (data.success) {
                // console.log(data);
                if (value === 'Retailer') {
                    setMappedUsers(data?.retailersLists);
                    setFilteredUsers(data?.retailersLists);
                } else if (value === 'Distributor') {
                    setMappedUsers(data?.distributorsList);
                    setFilteredUsers(data?.distributorsList);
                }

                //setWalletTransferHistory(data.transferHistory);
                //setFilteredWalletTransferHistory(data.transferHistory);
            }

        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setUserloading(false);
        }
    };

    useEffect(() => {
        const GetUserprofile = async () => {
            try {
                const data = await Get_User_Details();
                if (data.success) {
                    //console.log(data);
                    setProfiledetails(data?.user)
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setUserprofileLoading(false);
            }
        }
        const fetchusers = async () => {

            try {
                setUserloading(true);
                const data = await get_dist_and_retailers();
                if (data.success) {
                   // console.log(data);
                    if (whichuserLedger?.userType === 'Retailer') {
                        setMappedUsers(data?.retailersLists);
                        setFilteredUsers(data?.retailersLists);
                    } else if (whichuserLedger?.userType === 'Distributor') {
                        setMappedUsers(data?.distributorsList);
                        setFilteredUsers(data?.distributorsList);
                    }

                    //setWalletTransferHistory(data.transferHistory);
                    //setFilteredWalletTransferHistory(data.transferHistory);
                }

            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );

            } finally {
                setUserloading(false);
            }

        }
        if (user) {
            fetchusers();
            GetUserprofile();
        }

    }, [user, whichuserLedger]);
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Users</Title>
                <Text size="xs">Check your retailers/distributors details and status</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Card title="Mapped users" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={4}>
                            <Select
                                placeholder="Retailers"
                                data={userTypeOptions}
                                value={whichuserLedger.userType}
                                onChange={handleUserTypeChange}
                                loading={userprofileLoading}
                            // style={{ width: "100%" }}
                            />
                        </Col>
                        
                        <Col xs={24} md={4}>
                            <Select
                                value={userStatustype}
                                onChange={setUserstatus}
                                // style={{ width: "100%" }}
                                data={[
                                    { label: "ALL", value: "ALL" },
                                    { label: "Active", value: "Active" },
                                    { label: "Blocked", value: "Blocked" },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search by Name / Mobile / User Code"
                                allowClear
                                value={searchuser}
                                onChange={(e) => setSearchuser(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                                {/* <Button type="secondary" variant="outline" onClick={fetchuserledger}>
                                    Refresh
                                </Button> */}
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={filteredUsers}
                            loading={userfindloading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                        // scroll={{ x: 1200 }}
                        />
                    </div>
                </Card>
            </Container>

            <Drawer
                title="User Details"
                width={650}
                opened={UsersDrawer}
                onClose={() => setUsersDrawer(false)}
            >
                {selectedUser && (
                    <>
                        <Descriptions
                            title="Basic Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="User Code">
                                {selectedUser.userCode}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Name">
                                {selectedUser.userName}
                            </Descriptions.Item>

                            <Descriptions.Item label="Business Name">
                                {selectedUser.business_name || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Account Type">
                                <Tag color={selectedUser.acc_type === "Retailer" ? "blue" : "purple"}>
                                    {selectedUser.acc_type}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Gender">
                                {selectedUser.gender}
                            </Descriptions.Item>

                            <Descriptions.Item label="Mobile Number">
                                {selectedUser.mobile}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Address Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Address">
                                {selectedUser.address}
                            </Descriptions.Item>

                            <Descriptions.Item label="City">
                                {selectedUser.city}
                            </Descriptions.Item>

                            <Descriptions.Item label="State">
                                {selectedUser.state}
                            </Descriptions.Item>

                            <Descriptions.Item label="Pincode">
                                {selectedUser.pincode}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Divider />

                        <Descriptions
                            title="Account Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Created On">
                                {dayjs(selectedUser.createdAt).format(
                                    "DD MMM YYYY hh:mm:ss A"
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="Last Updated">
                                {dayjs(selectedUser.updatedAt).format(
                                    "DD MMM YYYY hh:mm:ss A"
                                )}
                            </Descriptions.Item>
                            <Descriptions.Item label="Account status">
                                {selectedUser.isaccountblocked === false ? <Tag color={'green'}>Active</Tag> : <Tag color={'red'}>Blocked</Tag>}
                            </Descriptions.Item>
                        </Descriptions>
                    </>
                )}
            </Drawer>
        </>
    )
}
export default Mappedusers;